module.exports = __webpack_public_path__ + "img/logo-sm-dark.5fd79548.png";